import { Col, Division, Row } from "@ir/ui";
import {
  UnresolvedDeductionsCard,
  RaisedForDisputeCard,
  DeductionsGrossSalesCard,
  DeductionsByPurchaserCard,
  DeductionsByTypeAndReasonCard,
  DeductionVolumeVsGrossSalesCard,
  DeductionsByAgingBracketsCard,
  DisputePipelineCard,
  DeductionsByRetailerCard,
} from "./components";
import "./styles/Analytics.page.scss";

const AnalyticsDashboardContent = () => {
  return (
    <Division className="analytics-dashboard">
      <Row className="mb-4" align="stretch" gutter={2}>
        <Col span={12} lg={4} className="mb-2">
          <UnresolvedDeductionsCard />
        </Col>
        <Col span={12} lg={4} className="mb-2">
          <RaisedForDisputeCard />
        </Col>
        <Col span={12} lg={4} className="mb-2">
          <DeductionsGrossSalesCard />
        </Col>
      </Row>
      <Row className="mb-4" align="stretch" gutter={2}>
        <Col span={12} lg={6} className="mb-2">
          <DeductionsByPurchaserCard />
        </Col>
        <Col span={12} lg={6} className="mb-2">
          <DeductionsByTypeAndReasonCard />
        </Col>
      </Row>
      <Row className="mb-4" align="stretch" gutter={2}>
        <Col span={12} lg={6} className="mb-2">
          <DeductionVolumeVsGrossSalesCard />
        </Col>
        <Col span={12} lg={6} className="mb-2">
          <DeductionsByAgingBracketsCard />
        </Col>
      </Row>
      <Row className="mb-4" align="stretch" gutter={2}>
        <Col span={12} lg={6} className="mb-2">
          <DisputePipelineCard />
        </Col>
        <Col span={12} lg={6} className="mb-2">
          <DeductionsByRetailerCard />
        </Col>
      </Row>
    </Division>
  );
};

export default AnalyticsDashboardContent;
